<style>
    textarea[name="remark"] {
        resize: none;
    }
</style>


<!-- Risk Description and Status Row -->
<div class="row align-items-center" style="margin-left:1%;">
    <!-- Left: Risk Description -->
    <div class="col-md-10 col-9">
        <h4 style="padding-right: 10px; margin-bottom:0;">
            Risk Description : {{criteriaName.EvaluationCriteria}}
        </h4>
    </div>
    <!-- Right: Status -->
    <div class="col-md-2 col-3 text-right">
        <span class="btn-sm ml-2"
            [ngClass]="{'btn-warning': !submitBtnStatus, 'btn-success': submitBtnStatus}"
            style="cursor:pointer; height: 28px; line-height: 30px; padding: 10px; vertical-align: middle;">
            {{submitBtnStatus ? "Completed" : "Not Completed"}}
        </span>
    </div>
</div>

<!-- Risk Department Row -->
<div class="row" style="margin-left:1%; margin-top:6px;">
    <div class="col-md-12">
        <h4 style="padding-right: 10px; margin-bottom:0;">
            Risk Department : {{deptName?.RiskDepartment}}
        </h4>
    </div>
</div>

<hr style="width: 100%; margin: 20px 0;">

    <div class="col-md-12">
        <div class="form-group row">
            <div class="col-md-2">
                <h5 style="font-weight: bold; padding-right: 10px;">Question:</h5>
            </div>
            <div class="col-md-10">
                <h5>{{question.QuestionText}}</h5>
            </div>
        </div>
        <div class="checkbox-new">

            <div class="form-group row">
                <label class="col-md-2 col-form-label" style="margin-top: 2%;" for="l0">Score Range
                    <sup style="color:red;">*</sup>
                </label>

                <div class='col-md-10 checkbox-new col-form-label'>

                    <div class="row">


                        <div *ngFor="let assessee of assesseeListToExecute; let count = index"
                            style="margin-right:2%">
                            <label>{{ assessee.assesseeName }}</label>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="ft-Wt600">Probability (In times)</label>
                                        <ng-select [items]="probabilityOptions" bindLabel="label"
                                            bindValue="value" [(ngModel)]="assessee.selectedProbability"
                                            (change)="changedAnswerScore(assessee)" placeholder="Select Probability"
                                            [clearable]="false">
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="ft-Wt600">Impact (In %)</label>
                                        <input type="text" class="form-control" name="impactPercent"
                                            [(ngModel)]="assessee.impactPercent" #impactPercentField="ngModel"
                                            pattern="^(100(\.0+)?|[1-9]?[0-9](\.[0-9]+)?)(%)?$" required
                                            (ngModelChange)="validateAndFormatPercent(assessee)"
                                            (change)="changedAnswerScore(assessee)" />

                                        <div *ngIf="impactPercentField.invalid && impactPercentField.touched"
                                            class="text-danger">
                                            Enter a valid percent between 1 and 100 (decimals allowed, optional %
                                            symbol)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>



<div class="form-group row" *ngIf="commentEnable">

    <div class="form-check" style="margin-bottom:1%"
        *ngFor="let assessee of answerListAsPerAssesseeList;let subcount = index">
        <label class="form-check-label">
            <input class="answersControl" type="radio" name="comments" [value]="assessee.assesseeId"
                (change)="changeUserForComments($event,assessee)">&nbsp;{{assessee.assesseeName}}
        </label>
    </div>
    <textarea style="width:90%;margin-left: 1%;border-color: #e4e9f0; min-height: 200px;" class="form-control"
        name="comments" [(ngModel)]="overallComments.Comments"></textarea>

</div>


<!-- control buttons start here -->
<div class="form-group row text-center" *ngIf="!commentEnable">
    <div class="col-md-12">

        <button class="btn btn-sm btn-style" type="button" *ngIf="enableNextButton && isNextButtonEnabled"
            (click)="next($event)" title="Save" id="save">
            Save and Next
        </button>

        <button class="btn btn-sm btn-primary ml-2" *ngIf="!(!submitBtnStatus && isNextButtonEnabled)"
            [disabled]="(!submitBtnStatus && isNextButtonEnabled) || (!enableNextButton && !isNextButtonEnabled) || IsFormEvaluated"
            style="cursor: pointer;" type="button" (click)="confirmSubmitEvaluationExecution()">{{submitBtnStatus ?
            "Submit Evaluation" : "Not Completed"}}
        </button>
    </div>
</div>
<div class="form-group row" *ngIf="!commentEnable">
    <div style="width:100%; text-align: left;">
        <span style="color: #ff0000">*</span> Indicates Mandatory field
    </div>
    <div class="col-lg-12" style="text-align: right;">
    </div>
</div>

<div class="form-group row" *ngIf="commentEnable">
    <div class="col-lg-12" style="text-align: right;">
        <button class="btn btn-sm btn-primary ml-2 pull-right" style="cursor: pointer;margin-right:5%" type="button"
            (click)="submitComments()">Submit Comments</button>
    </div>
</div>

<div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px; z-index: 9999;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div id="alertPopUpTitle" class="modal-header"
                style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                Title!
            </div>
            <div class="modal-body" style="padding: 10px 15px;">
                <div id="alertMessage" style="font-size: 16px;">
                    Message..
                </div>
            </div>
        </div>
    </div>
</div>


<!--confirm delete evaluation dialogbox-->
<div class="modal fade" id="submitEvaluationModal" role="dialog" aria-labelledby="submitEvaluationModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="submitEvaluationModalLabel">
                    <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to submit the scores, once submitted won't be able to edit</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="submitEvaluationExecution()">Confirm
                </button>
                <button type="button" class="btn btn-default btn-sm" data-dismiss="modal"
                    (click)="closeForm('submitEvaluationModal')">Cancel</button>
            </div>
        </div>
    </div>
</div>